// Enum for expense types to avoid hard-coded strings
export const ExpenseTypeEnum = {
    BaggageFee: 'BaggageFee',
    Fuel: 'Fuel',
    LodgingSecurityDeposit: 'LodgingSecurityDeposit',
    Mileage: 'Mileage',
    Misc: 'Misc',
    Rent: 'Rent',
};
